import React, { useEffect, useState } from "react";
//Bootstrap
import IncomeTableRows from "./IncomeTableRows";
//Components
import TableHead from "../TableHead/TableHead";

export default function IncomeTable({
  incomes,
  setIncomes,
  incomeRows,
  setIncomeRows,
  tableHeads,
  deleteMonth,
}) {
  const [showIncomes, setShowIncomes] = useState(true);

  useEffect(() => {
    var month1 = 0;
    var month2 = 0;
    var month3 = 0;
    var month4 = 0;
    var month5 = 0;
    var month6 = 0;
    var month7 = 0;
    var month8 = 0;
    var month9 = 0;
    var month10 = 0;
    var month11 = 0;
    var month12 = 0;
    incomeRows.map((row) => {
      month1 += Number(row.incomeOne);
      month2 += Number(row.incomeTwo);
      month3 += Number(row.incomeThree);
      month4 += Number(row.incomeFour);
      month5 += Number(row.incomeFive);
      month6 += Number(row.incomeSix);
      month7 += Number(row.incomeSeven);
      month8 += Number(row.incomeEight);
      month9 += Number(row.incomeNine);
      month10 += Number(row.incomeTen);
      month11 += Number(row.incomeEleven);
      month12 += Number(row.incomeTwelve);
    });
    setIncomes({
      month1: month1,
      month2: month2,
      month3: month3,
      month4: month4,
      month5: month5,
      month6: month6,
      month7: month7,
      month8: month8,
      month9: month9,
      month10: month10,
      month11: month11,
      month12: month12,
    });
  }, [incomeRows]);

  const addRow = (id, details) => {
    const randomId = (Math.random() + 1).toString(36).substring(7);

    var newest;
    newest = incomeRows.slice(-1)[0];
    if (details) {
      //then create a blank new row
      if (id === "0i123") {
        if (incomeRows.length) {
        } else {
          const newEntry = {
            id: id,
          };
          setIncomeRows((prev) => {
            return [...prev, newEntry];
          });
        }
      }
    }

    if (!details) {
      //then create a blank new row
      if (id === newest.id) {
        const newEntry = {
          id: randomId,
          title: "",
          incomeOne: 0,
          incomeTwo: 0,
          incomeThree: 0,
          incomeFour: 0,
          incomeFive: 0,
          incomeSix: 0,
          incomeSeven: 0,
          incomeEight: 0,
          incomeNine: 0,
          incomeTen: 0,
          incomeEleven: 0,
          incomeTwelve: 0,
        };
        setIncomeRows((prev) => {
          return [...prev, newEntry];
        });
      }
    }
  };

  const removeRow = (id) => {
    if (incomeRows.length !== 1) {
      setIncomeRows((prev) => {
        return prev.filter((row) => {
          return row.id !== id;
        });
      });
    }
  };

  const setField = (field, id, value) => {
    let current = incomeRows.find((row) => row.id === id);

    if (current) {
      current[field] = value;

      setIncomeRows([...incomeRows]);
    } else {
      const row = {
        [field]: value,
        id: id,
      };
      setIncomeRows([...incomeRows, { row }]);
    }
  };

  const updateShow = () => {
    setShowIncomes(!showIncomes);
  };

  return (
    <div className="">
      <table className="incomeTable">
        <thead className="incomeTableheadborder">
          <TableHead
            header={"Income"}
            tableHeads={tableHeads}
            deleteMonth={deleteMonth}
            updateShow={updateShow}
            show={showIncomes}
          />
        </thead>
        <tbody className="">
          {showIncomes &&
            incomeRows.map((row) => (
              <IncomeTableRows
                id={row.id}
                key={row.id}
                row={row}
                addRow={addRow}
                removeRow={removeRow}
                setField={setField}
                incomeRows={incomeRows}
              />
            ))}
        </tbody>
        <tfoot className="foot incomeFoot">
          <tr>
            <td></td>
            <td>{incomes.month1}</td>
            <td>{incomes.month2}</td>
            <td>{incomes.month3}</td>
            <td>{incomes.month4}</td>
            <td>{incomes.month5}</td>
            <td>{incomes.month6}</td>
            <td>{incomes.month7}</td>
            <td>{incomes.month8}</td>
            <td>{incomes.month9}</td>
            <td>{incomes.month10}</td>
            <td>{incomes.month11}</td>
            <td>{incomes.month12}</td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}
